import React, { useEffect, useState } from "react";
import GenericTable from "../../genericComponents/genericTableComp/GenericTable";
import ResizableDivForTag from "../../uiUtils/resizeobs/ResizableDivForTag";
import TextWithTooltip from "../../GlobalContacts/TextWithTooltip";

const baseColumns = [
  { id: "opportunity_name", label: "Name", width: 55, clickAction: true, alignment: "left" },
  { id: "opportunity_description", label: "Description", width: 100, alignment: "flex-start" },
  { id: "mapped_products", label: "My Offerings", width: 80, alignment: "flex-start" },
  { id: "relevance", label: "Relevance", width: 60, alignment: "flex-start" },
  { id: "signal", label: "Signal", width: 60, alignment: "flex-start" },
];

function OppTableContainer({ data }) {
    console.log("OppTableContainer data",data)
  const [tabData, setTabData] = useState([]);

  useEffect(() => {
    const enhanced = data.map((item) => ({
      ...item,
      opportunity_description: (
        <TextWithTooltip
          text={item?.opportunity_description}
          className="two-line-ellipsis"
        />
      ),

      mapped_products: (
        <ResizableDivForTag
          handleSideCard={() => {}}
          items={(
            Array.isArray(item?.mapped_products)
              ? item?.mapped_products
              : typeof item?.mapped_products === "string"
              ? item?.mapped_products.split(",").map((s) => s.trim())
              : []
          ).map((e) => ({ key: e, label: e }))}
          rowData={item}
        />
      ),
    }));

    setTabData(enhanced);
  }, [data]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "16px",
        padding: "1.5rem 1.2rem",
        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
        border: "1px solid #E5E7EB",
      }}
    >
      {/* Header */}
      <div
        style={{
          fontSize: "1.25rem",
          fontWeight: "700",
          marginBottom: "0.8rem",
          color: "#111827",
          letterSpacing: "0.3px",
        }}
      >
        Opportunities Found
      </div>

      {/* Sub Divider */}
      <div
        style={{
          height: "1px",
          width: "100%",
          background: "#E5E7EB",
          marginBottom: "1.3rem",
        }}
      />

      {/* Table Container */}
      <div
        style={{
          width: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          borderRadius: "12px",
          border: "1px solid #E5E7EB",
        }}
      >
        <div style={{ minWidth: "950px" }}>
          <GenericTable
            initialColumns={baseColumns}
            tabData={tabData}
            loading={false}
            loadingRows={5}
            disableSort={true}
          />
        </div>
      </div>
    </div>
  );
}

export default OppTableContainer;
